export default __webpack_public_path__ + "static/media/demoImg.2257e625.png";